var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InputSelect, } from '@isyc-react/form/modules/input/select';
import { OverlayTrigger, Spinner, Tooltip } from '@isyc-react/design/bootstrap';
import { RhfFieldError, rhfMapperReq, useController } from '@isyc-react/form/modules/rhf';
import { validBailleursParameter } from './rhf-input-bailleurs-parameter.component';
import options from './commune.json';
const sep = ',';
export const InputCommune = props => {
    const { value: valueProp = null, onChange, required, resultsBySearch = 30, departament: inDepartament = undefined, data: parameterData } = props, rest = __rest(props, ["value", "onChange", "required", "resultsBySearch", "departament", "data"]);
    const { parameterId } = parameterData;
    const [departament, setDepartament] = React.useState();
    React.useEffect(() => {
        if (departament != undefined && (inDepartament === null || inDepartament === void 0 ? void 0 : inDepartament.value) != (departament === null || departament === void 0 ? void 0 : departament.value)) {
            onChange && valueProp && onChange(Object.assign(Object.assign({}, valueProp), { value: '', comboCodeLabel: '' }));
        }
        setDepartament(inDepartament);
    }, [inDepartament]);
    const cleanValue = (input) => input
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    const optionsByDistrict = React.useMemo(() => {
        const newOptionsByDistrict = {};
        options
            .filter(df => df !== null)
            .forEach(df => {
            var _a;
            var _b;
            ((_a = newOptionsByDistrict[_b = df.value.substring(0, 2)]) !== null && _a !== void 0 ? _a : (newOptionsByDistrict[_b] = [])).push(Object.assign(Object.assign({}, df), { cleanValue: cleanValue(df.label) }));
        });
        return newOptionsByDistrict;
    }, [options]);
    const getDistrictCode = (value) => value.substring(0, 2);
    const currentOptionByDistrict = React.useMemo(() => {
        return (departament === null || departament === void 0 ? void 0 : departament.value) &&
            optionsByDistrict[getDistrictCode(departament === null || departament === void 0 ? void 0 : departament.value)] ?
            optionsByDistrict[getDistrictCode(departament === null || departament === void 0 ? void 0 : departament.value)] : [];
    }, [departament, optionsByDistrict]);
    const selectedOption = React.useMemo(() => {
        return valueProp ? { value: valueProp === null || valueProp === void 0 ? void 0 : valueProp.value, label: valueProp === null || valueProp === void 0 ? void 0 : valueProp.comboCodeLabel } : undefined;
    }, [valueProp]);
    const getDisabled = React.useCallback(() => {
        return (departament === null || departament === void 0 ? void 0 : departament.value) == undefined || (departament === null || departament === void 0 ? void 0 : departament.value) == '';
    }, [departament]);
    return (React.createElement(React.Fragment, null, options == undefined ? (React.createElement(Spinner, { animation: 'border', size: 'sm' })) : (React.createElement(InputSelect, Object.assign({ value: selectedOption, defaultValue: selectedOption, onChange: field => {
            var _a, _b;
            onChange && valueProp && onChange(Object.assign(Object.assign({}, valueProp), { value: (_a = field === null || field === void 0 ? void 0 : field.value) !== null && _a !== void 0 ? _a : '', comboCodeLabel: (_b = field === null || field === void 0 ? void 0 : field.label) !== null && _b !== void 0 ? _b : '' }));
        }, options: currentOptionByDistrict, disabled: getDisabled() }, rest))
    /*
    <InputAsyncMultiSelect
      defaultValue={selectedOptions}
      promise={callAsync}
      onChange={c => {
        onChange && valueProp && onChange({
          ...valueProp, code: c.map(e => e.value).join(sep),
          label: c.map(e => e.label).join(sep)
        })
      }}
      isClearable={!required}
      {...rest}
    />
  ) : (
    <InputAsyncSelect
      defaultInputValue={selectedOptions && selectedOptions[0] ? selectedOptions[0].label : undefined}
      promise={callAsync}
      onChange={c => {
        onChange && valueProp && onChange({ ...valueProp, ...c })
      }}
      isClearable={!required}
      disabled={getDisabled()}
      input={{ ...{ noOptionsMessage: (() => 'Ecrit pour chercher') } as any }}
      {...rest}
    />
    */
    )));
};
export const RhfInputCommune = props => {
    var _a;
    const { rhf, errorMessage, input, departament } = props, rest = __rest(props, ["rhf", "errorMessage", "input", "departament"]);
    const { field: { onChange, onBlur, name, value, ref }, fieldState: { error }, } = useController(rhfMapperReq(rhf, (p) => Boolean(p.value), {
        valid: (p) => validBailleursParameter(p.value, p),
    }));
    const data = value;
    const required = (_a = rhf.rules) === null || _a === void 0 ? void 0 : _a.required;
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: 'form-label' },
            data.label,
            " ",
            (required) && React.createElement("span", { className: 'required' }, "*"),
            (data.remarks) && (React.createElement(OverlayTrigger, { delay: { show: 250, hide: 0 }, overlay: React.createElement(Tooltip, null, data.remarks) },
                React.createElement("i", { className: 'mdi mdi-information text-light-secondary ms-2' })))),
        React.createElement("div", null,
            React.createElement(InputCommune, Object.assign({ onChange: onChange, onBlur: onBlur, value: value, data: data, error: Boolean(error), departament: departament }, input, rest)),
            React.createElement(RhfFieldError, { errorMessage: errorMessage, error: error }))));
};
